import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import GenericPaymentMethod from './GenericPaymentMethod';
import PayPage from './CbPayment/PayPage';
import Iframe from './Iframe/Iframe';
import BankCardIcon from 'components/Common/Icons/BankCard';
import PaymentMethod from 'model/PaymentMethod';
import { MethodProps } from 'types/PaymentFormType';
import { getMode, IFRAME_MODE, PAYPAGE_MODE } from 'services/sips';

import CBLogo from 'assets/img/Payment/Logo_GIE-CB.svg';
import VisaLogo from 'assets/img/Payment/Symbole-Visa.svg';
import MasterCardLogo from 'assets/img/Payment/Mastercard_2019_logo.svg';

import styles from './PaymentMethod.module.scss';

function CbPaymentMethod({
  changeSubmitButtonVisibility,
  isSelected,
  setPaymentMethod,
  handleClick,
}: MethodProps): JSX.Element | null {
  const { t } = useTranslation(['checkout']);
  const renderMode = useMemo(() => getMode(), []);

  useEffect(() => {
    if (renderMode === IFRAME_MODE) {
      changeSubmitButtonVisibility(!isSelected);
    }
  }, [isSelected]);

  if (!renderMode) {
    // Hide the method because the mode doesn't exist.
    return <></>;
  }

  return (
    <GenericPaymentMethod
      value={PaymentMethod.cb}
      classes={{
        methodTitle: styles.cbMethodTitle,
      }}
      labelContent={
        <>
          <span className={styles.methodLogo}>
            <BankCardIcon />
          </span>
          <span className={styles.methodText}>{t('CB_METHOD_TITLE')}</span>
          <span>
            <img src={CBLogo} alt={'CB Logo'} />
          </span>
          <span>
            <img src={VisaLogo} alt={'Visa Logo'} />
          </span>
          <span>
            <img src={MasterCardLogo} alt={'Master card Logo'} />
          </span>
        </>
      }
    >
      {isSelected && (
        <div className={styles.cbMethodContentContainer}>
          {renderMode === IFRAME_MODE && (
            <Iframe
              setPaymentMethod={setPaymentMethod}
              paymentMethod={PaymentMethod.cb}
            />
          )}
          {renderMode === PAYPAGE_MODE && (
            <PayPage
              handleClick={handleClick}
              setPaymentMethod={setPaymentMethod}
            />
          )}
        </div>
      )}
    </GenericPaymentMethod>
  );
}

export default CbPaymentMethod;
